/**
 * Shared Cart Modal Configuration
 * Arquivo de configuração para personalizar o comportamento do modal
 */

window.SHARED_CART_CONFIG = {
  API_BASE_URL: 'https://one-personal-shopper.gadget.app',
  API_ENDPOINT: '/cart',
  REQUEST_TIMEOUT: 10000,
  
  MODAL: {
    TITLE: 'Personal Shopper',

    MESSAGES: {
      LOADING: 'Carregando...',
      ERROR: 'Erro ao carregar os dados do cart compartilhado.',
      NOT_FOUND: 'Cart não encontrado.',
      NETWORK_ERROR: 'Erro de conexão. Verifique sua internet.'
    },
    
    ANIMATIONS: {
      ENABLED: true,
      DURATION: 300
    }
  },
  
  API_HEADERS: {
    'Content-Type': 'application/json'
  }
};

window.SHARED_CART_CONFIG.getApiUrl = function(cartId) {
  return `${this.API_BASE_URL}${this.API_ENDPOINT}/${cartId}`;
};

window.SHARED_CART_CONFIG.validate = function() {
  if (!this.API_BASE_URL) {
    console.warn('[SharedCart] ⚠️ API_BASE_URL não foi configurado!');
    return false;
  }
  return true;
};

document.addEventListener('DOMContentLoaded', () => {
  window.SHARED_CART_CONFIG.validate();
});
